/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * One filter position per analysis model. Merges analyticprocess and analyticfiltertype. A many_to_one mapping is necessary to both AnalyticFilterType and analyticProcess. A one_to_many mapping is necessary for AnalyticFilterData.
 */
export interface AnalyticFilterDefinition { 
    /**
     * Internal AnalyticFilterDefinition Key
     */
    analyticFilterDefinition_id?: number;
    /**
     * Filter position of AnalyticFilterDefinition
     */
    analyticFilterDefinition_filterPos?: number;
    /**
     * Filter value type of AnalyticFilterDefinition
     */
    analyticFilterDefinition_filterValueType?: string;
    /**
     * Filter name of AnalyticFilterDefinition
     */
    analyticFilterDefinition_filterName?: string;
    /**
     * MinOverride flag of AnalyticFilterDefinition
     */
    analyticFilterDefinition_minOverride?: number;
    /**
     * Parameter name of AnalyticFilterDefinition
     */
    analyticFilterDefinition_paramName?: string;
    /**
     * Id of the AnalyticFilterType
     */
    analyticfiltertype_id?: number;
    /**
     * Filter name in AnalyticFilterType
     */
    analyticfiltertype_filterName?: string;
    /**
     * Control type in AnalyticFilterType
     */
    analyticfiltertype_controltype?: string;
    /**
     * Multi-flag in AnalyticFilterType
     */
    analyticfiltertype_multi?: number;
    /**
     * Min-Max flag in AnalyticFilterType
     */
    analyticfiltertype_minMax?: number;
    /**
     * Description in AnalyticFilterType
     */
    analyticfiltertype_description?: string;
    /**
     * Start value for numeric filter in AnalyticFilterType
     */
    analyticfiltertype_startwertNum?: number;
    /**
     * Start value for character filter in AnalyticFilterType
     */
    analyticfiltertype_startwertChar?: string;
    /**
     * Placeholder in AnalyticFilterType
     */
    analyticfiltertype_placeHolder?: string;
    /**
     * Validators in AnalyticFilterType
     */
    analyticfiltertype_validatoren?: number;
    /**
     * SkipAll flag in AnalyticFilterType
     */
    analyticfiltertype_skipAll?: number;
}

